import { c as _c } from "react/compiler-runtime";
import { LayoutTrueFAQ, TrueFaqEntry } from "@/components/terra/layouts/LayoutTrueFAQ/LayoutTrueFAQ";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
export default function MXPEmbeddedFaqs(props) {
  const $ = _c(4);
  const {
    value
  } = props;
  let t0;
  if ($[0] !== value.itemsCollection?.items) {
    t0 = (value.itemsCollection?.items ?? []).filter(Boolean).flatMap(_temp2);
    $[0] = value.itemsCollection?.items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const items = t0;
  let t1;
  if ($[2] !== items) {
    t1 = <LayoutTrueFAQ items={items} isEmbedded={true} />;
    $[2] = items;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp2(item) {
  if (item.__typename === "TrueFaqItem") {
    return [{
      type: "faq",
      data: {
        question: item.question || "",
        answer: item.answer?.json ? documentToHtmlString(item.answer.json) : ""
      }
    }];
  }
  if (item.__typename === "TrueFaqTab") {
    const tabFaqs = (item.itemsCollection?.items ?? []).filter(Boolean).map(_temp);
    return [{
      type: "tab",
      data: {
        title: item.title || "",
        items: tabFaqs
      }
    }];
  }
  return [];
}
function _temp(faqItem) {
  return {
    question: faqItem.question || "",
    answer: faqItem.answer?.json ? documentToHtmlString(faqItem.answer.json) : ""
  };
}